import MarkdownIt from 'markdown-it';
import plainText from 'markdown-it-plain-text';
import xss from 'xss';

export function mdToPlain(value: string) {
    const md = new MarkdownIt().use(plainText) as MarkdownIt & { plainText: string };
    md.render(value);
    return xss(md.plainText, {
        whiteList: {}, // empty, means filter out all tags
        stripIgnoreTag: true, // filter out all HTML not in the whitelist
        stripIgnoreTagBody: ['script'] // the script tag is a special case, we need to filter out its content as well
    });
}
